import React, { useCallback } from "react";
import { Link } from "react-router-dom";

import { Navbar } from "../../../components/common/u1/Navbar";
import { Button } from "../../../components/common/u1/Button";
import { ArrowRight } from "../../../assets/ui/icons";
import {
  useResetFlow,
  STEP_EMAIL,
  STEP_SENT,
  STEP_PASSWORD,
  STEP_DONE,
} from "../../../components/public/ResetPassword/u1/useResetFlow";
import { EmailStep } from "../../../components/public/ResetPassword/u1/EmailStep";
import { SentStep } from "../../../components/public/ResetPassword/u1/SentStep";
import { PasswordStep } from "../../../components/public/ResetPassword/u1/PasswordStep";
import { DoneStep } from "../../../components/public/ResetPassword/u1/DoneStep";
import "../../../components/common/u1/tokens.css";

/* u1 Reset / Set password — /u1/reset-password and /u1/set-password. */
export default function ResetPassword({ route = null }) {
  const {
    step,
    email,
    handleEmailNext,
    handleVerifyNext,
  } = useResetFlow();

  /* Stable identity: useForgotEmail's mount effect depends on this callback, so
     a new function on every render would re-run the link check each time. */
  const handleLinkedToken = useCallback(handleVerifyNext, [handleVerifyNext]);

  return (
    <div className="u1-root min-h-screen w-full bg-[var(--bg)] flex flex-col">
      {/* Only the one call to action, as on login: a "Log in" link here would
          point back at the screen this flow exists to get you into. */}
      <Navbar
        actions={
          <Link to="/sign-up">
            <Button variant="primary" className="whitespace-nowrap">
              List your business <ArrowRight size={14} />
            </Button>
          </Link>
        }
      />

      {step === STEP_EMAIL && (
        <EmailStep
          email={email}
          onNext={handleEmailNext}
          onLinkedToken={handleLinkedToken}
        />
      )}
      {step === STEP_SENT && <SentStep email={email} />}
      {step === STEP_PASSWORD && <PasswordStep route={route} />}
      {step === STEP_DONE && <DoneStep />}
    </div>
  );
}
